import { jsx as r } from "react/jsx-runtime";
import s from "../alert-banner/alert-banner.js";
import d from "./alert-banner-list.module.less.js";
const n = ({ alertBanners: e }) => /* @__PURE__ */ r("ul", { className: `max-width padded-sides centered ${d.wrapper}`, children: e.map((t, a) => /* @__PURE__ */ r("li", { children: /* @__PURE__ */ r(s, { ...t }) }, a)) });
export {
  n as default
};
